import React, { useState } from 'react';

function buildShareText(product, productUrl) {
  const lines = [];
  lines.push(product.title);
  lines.push('');

  // Price
  if (product.priceOnConsultation) {
    lines.push('Precio: A convenir');
  } else if (product.price != null) {
    const symbol = product.currency === 'USD' ? 'US$' : '$';
    lines.push(`Precio: ${symbol}${Number(product.price).toLocaleString('es-UY')}`);
  }

  // Condition
  if (product.condition) {
    lines.push(`Estado: ${product.condition === 'NEW' ? 'Nuevo' : 'Usado'}`);
  }

  // Category
  if (product.category) {
    lines.push(`Categoria: ${product.category}`);
  }

  // Location
  const loc = [product.city, product.department].filter(Boolean).join(', ');
  if (loc) lines.push(`Ubicacion: ${loc}`);

  // Description (truncated)
  if (product.description) {
    const desc = product.description.length > 200
      ? product.description.substring(0, 200) + '...'
      : product.description;
    lines.push('');
    lines.push(desc);
  }

  lines.push('');
  lines.push(`Ver publicacion: ${productUrl}`);
  lines.push('');
  lines.push('Publicado en MercadoLibertario.uy');

  return lines.join('\n');
}

/** Open a centered popup window on desktop */
function openPopup(url, w, h) {
  const left = (window.screen.width - w) / 2;
  const top = (window.screen.height - h) / 2;
  window.open(url, '_blank', `width=${w},height=${h},left=${left},top=${top},noopener,noreferrer`);
}

function ShareButtons({ product, canonicalUrl }) {
  const [copied, setCopied] = useState(false);

  const productUrl = canonicalUrl || window.location.href;
  const shareText = buildShareText(product, productUrl);
  const firstImage = product.imageUrls?.[0] || null;

  const handleWhatsApp = () => {
    openPopup(`https://wa.me/?text=${encodeURIComponent(shareText)}`, 700, 600);
  };

  const handleFacebook = () => {
    const params = new URLSearchParams({
      u: productUrl,
      quote: shareText,
    });
    openPopup(`https://www.facebook.com/sharer/sharer.php?${params}`, 600, 500);
  };

  const handleNativeShare = async () => {
    const shareData = {
      title: product.title,
      text: shareText,
      url: productUrl,
    };
    try {
      await navigator.share(shareData);
    } catch {
      // User cancelled or not supported — fall through
    }
  };

  const handleCopy = async () => {
    // If the product has an image, try to copy both image + text to clipboard
    if (firstImage && window.ClipboardItem) {
      try {
        const resp = await fetch(firstImage);
        const blob = await resp.blob();
        await navigator.clipboard.write([
          new window.ClipboardItem({
            [blob.type]: blob,
            'text/plain': new Blob([shareText], { type: 'text/plain' }),
          }),
        ]);
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
        return;
      } catch {
        // Fall through to text-only copy
      }
    }

    // Text-only fallback
    try {
      await navigator.clipboard.writeText(shareText);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = shareText;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const canNativeShare = typeof navigator.share === 'function';

  return (
    <div className="detail-share">
      <span className="detail-share-label">Compartir:</span>
      <button type="button" className="btn btn-sm contact-btn-wa" onClick={handleWhatsApp}>
        WhatsApp
      </button>
      <button type="button" className="btn btn-sm btn-facebook" onClick={handleFacebook}>
        Facebook
      </button>
      <button
        type="button"
        className={`btn btn-sm ${copied ? 'btn-success' : 'btn-secondary'}`}
        onClick={handleCopy}
      >
        {copied ? 'Copiado!' : 'Copiar texto'}
      </button>
      {canNativeShare && (
        <button type="button" className="btn btn-sm btn-secondary" onClick={handleNativeShare}>
          Mas...
        </button>
      )}
    </div>
  );
}

export default ShareButtons;
